import { render } from "./IndexProvider.vue?vue&type=template&id=63b2c715"
import script from "./IndexProvider.vue?vue&type=script&lang=js"
export * from "./IndexProvider.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__